<template>
  <div>
    <h1>Analytics</h1>
    <p>Show analytics and reports here.</p>
  </div>
</template>

<script>
export default {
  name: "AnalyticsComponent",
};
</script>
